import { SET_MODAL_SAMPLE_VIDEO } from 'store/types/sample-video';

const initialState = {
  modalSampleVideo: {
    isOpen: false,
    isEdit: false,
    id: null,
  },
};

const sampleVideoReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MODAL_SAMPLE_VIDEO:
      return {
        ...state,
        modalSampleVideo: action?.payload,
      };
    default:
      return state;
  }
};

export default sampleVideoReducer;
